<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['add_fees_payment'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-2" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <b-form-input v-model="year" type="number"></b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-4" label="Optional Fee Types">
                    <v-select
                      :options="optionalfees"
                      placeholder="Select Fee Type"
                      v-model="fees"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                  <div
                    class="col-md-3 d-flex justify-content-end mt-md-4 mt-2 p-lg-0 "
                  >
                    <div class="">
                      <div class="btn-group">
                        <b-button
                          v-b-modal.new-optionalfeespayment
                          size="sm"
                          variant="primary"
                          ><i class="mdi mdi-plus"></i> New Payment</b-button
                        >
                        <b-button
                          :disabled="optionalfeepayments.length <= 0"
                          type="button"
                          class="btn btn-sm btn-success"
                          @click="printPDF"
                          >PDF <i class="mdi mdi-file-pdf"></i
                        ></b-button>
                        <export-excel
                          type="button"
                          class="btn btn-sm btn-info"
                          :data="optionalfeepayments"
                          :name="this.title"
                        >
                          Excel <i class="mdi mdi-file-excel"></i
                        ></export-excel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive" id="print-section">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(fees)="data">
                    <b class="text-danger">{{ data.item.fees[0].name }}</b>
                    <br />
                  </template>
                  <template #cell(amount)="data">
                    <b class="text-danger">{{
                      commas(data.item.fees[0].amount)
                    }}</b>
                    <br />
                    <small
                      >{{ data.item.schoolterm[0].name }} -
                      {{ data.item.fees_payment.year }}</small
                    > </template
                  ><template #cell(amountpaid)="data">
                    <b class="text-success">{{
                      commas(data.item.sum_paid)
                    }}</b></template
                  >
                  <template #cell(bal)="data">
                    <b class="text-primary">
                      {{ commas(getBalance(data.item)) }}
                    </b>
                  </template>
                  <template #cell(created_at)="data">
                    {{ formatDate(data.item.fees_payment.created_at) }}
                  </template>
                  <template #cell(student)="data">
                    {{
                      data.item.student
                        ? data.item.student[0].first_name +
                          " " +
                          data.item.student[0].last_name
                        : "No student assigned"
                    }}<br />
                    <small
                      ><b>{{ data.item.student[0].student_id }}</b></small
                    >
                  </template>

                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <!-- <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.student.student_id,
                            data.item.fees,
                            data.item.schoolterm,
                            data.item.fees.amount,
                            data.item.amountpaid,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                        Edit</b-button
                      > -->
                      <b-button
                        v-if="getBalance(data.item) > 0"
                        @click="
                          pay(
                            data.item.fees_payment.id,
                            data.item.fees_payment.receipt_id,
                            data.item.student[0].student_id,
                            getBalance(data.item),
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="info"
                        v-b-modal.add
                      >
                        <i class="mdi mdi-cash"></i> Pay</b-button
                      >
                      <b-button
                        v-else
                        type="button"
                        class="btn-sm btn"
                        variant="success"
                        disabled
                      >
                        <i class="mdi mdi-check"></i> Paid</b-button
                      >
                      <b-button
                        @click="
                          remove(
                            data.item.fees_payment.id,
                            data.item.fees[0].name,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>Delete</b-button
                      >
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row d-flex justify-content-center">
                <div class="col">
                  Fees Payable : <b> {{ commas(totalfees) }}</b>
                </div>
                <div class="col">
                  Amount Paid :<b> {{ commas(totalpaid) }}</b>
                </div>
                <div class="col">
                  Balance :<b> {{ commas(totalfees - totalpaid) }}</b>
                </div>
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-optionalfeespayment"
        centered
        title="New Optional Fees Payments"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addFeesPayment">
          <label>Student : </label>
          <multiselect
            v-model="student"
            :options="students"
            placeholder="Select Student"
            :custom-label="customLabel"
          ></multiselect>
          <label>Year</label>
          <b-form-input v-model="year" type="number"></b-form-input>
          <label>Term</label>
          <multiselect
            v-model="schoolterm"
            label="name"
            :options="schoolterms"
          ></multiselect>
          <div class="form-group mb-2">
            <label>Fees</label>
            <multiselect
              v-model="fees"
              label="name"
              :options="optionalfees"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Fees Amount</label>
            <input
              v-model="fees.amount"
              readonly
              style="background: none;"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label>Amount Paid</label>
            <input
              v-model="amountpaid"
              type="number"
              required
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-optionalfeespayment')"
              >Close</b-button
            >
            <b-button
              type="submit"
              class="btn ms-1 w-30"
              variant="primary"
              :disabled="loader"
            >
              <b-spinner
                v-if="loader"
                small
                class="mr-1"
                label="Small Spinner"
              /><i v-else class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-optionalfeespayment"
        centered
        title="Edit Optional Fees Payments"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editFeesPayment">
          <label
            >Student : <small class="text-primary">{{ student }}</small></label
          >
          <v-select
            readonly="true"
            :options="students"
            placeholder="Select Student"
            v-model="student"
            :reduce="(students) => students.student.student_id"
          >
            <template slot="option" slot-scope="option">
              <div>
                {{ option.student.first_name }} {{ option.student.last_name }}
                {{ option.class.name }} {{ option.stream.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div>
                {{ option.student.first_name }} {{ option.student.last_name }}
                {{ option.class.name }} {{ option.stream.name }}
              </div>
            </template>
          </v-select>
          <label>Term</label>
          <multiselect
            v-model="schoolterm"
            label="name"
            :options="schoolterms"
          ></multiselect>
          <label>Year</label>
          <b-form-input v-model="year" type="number"></b-form-input>
          <div class="form-group mb-2">
            <label>Fees</label>
            <multiselect
              v-model="fees"
              label="name"
              @input="setFees()"
              :options="optionalfees"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Fees Amount</label>
            <input
              v-model="amount"
              readonly
              style="background: none;"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label>Amount Paid</label>
            <input
              v-model="amountpaid"
              type="number"
              required
              class="form-control"
            />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-optionalfeespayment')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="make-payment"
        centered
        title="Make Optional Fee Payment"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="makePayment">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <div class="row">
              <div class="col-md-6">
                <label> Balance</label>
                <input
                  type="number"
                  v-model="bal"
                  class="form-control"
                  readonly
                />
              </div>
              <div class="col-md-6">
                <label>Amount to Pay</label>
                <input
                  type="number"
                  v-model="amount_paid"
                  class="form-control"
                  required
                  :max="bal"
                />
              </div>
            </div>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('make-payment')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-optionalfeespayment"
        centered
        title="Delete Optional Fees Payments"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesPayment">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Optional Fees Payments :
          <b>{{ name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-optionalfeespayment')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import html2pdf from "html2pdf.js";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

import {
  feescartComputed,
  feescartMethods,
  optionalfeeComputed,
  optionalfeeMethods,
  optionalfeepaymentComputed,
  optionalfeepaymentMethods,
  paymentoptionComputed,
  paymentoptionMethods,
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "Optional Fees Payments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Optional Fees Payments",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Optional Fees Payments", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student", label: "Student", visible: true },
        { key: "fees", label: "Fee Type", visible: true },
        { key: "amount", label: "Fees Amount", visible: true },
        { key: "amountpaid", label: "Amount Paid", visible: true },
        { key: "bal", label: "Balance", visible: true },
        { key: "created_at", label: "Pay Date", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      schoolclass: "",
      schoolterm: "",
      year: new Date().getFullYear(),
      fees: "",
      student: "",
      amount: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      amountpaid: "0",
      setoptionalfees: [],
      setpayments: [],
      bal: "",
      receipt_id: "",
      name: "",
      amount_paid: "",
      loader: false,
    };
  },
  computed: {
    ...optionalfeeComputed,
    ...optionalfeepaymentComputed,
    ...schoolclassComputed,
    ...schooltermComputed,
    ...studentComputed,
    ...feescartComputed,
    ...paymentoptionComputed,
    List() {
      return this.optionalfeepayments.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.optionalfeepayments.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.optionalfeepayments.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    totalfees() {
      var total = 0;
      this.optionalfeepayments.forEach((item) => {
        var item_total = Number(item.fees[0].amount ?? 0);
        total = Number(total) + Number(item_total);
      });
      return total;
    },
    totalpaid() {
      var total = 0;
      this.optionalfeepayments.forEach((item) => {
        var item_total = Number(
          item?.sum_paid ?? item?.amountpaid ?? item?.amount_paid ?? 0,
        );
        total = Number(total) + Number(item_total);
      });
      return total;
    },
  },
  mounted() {
    this.fetchOptionalFees();
    this.fetchOptionalFeesPayments();
    this.fetchStudents();
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.fetchFeesCart();
    this.fetchPaymentoptions();
    this.TotalRows = this.optionalfeepayments.length;
    this.isBusy = false;
    this.payoption = this.paymentoptions.find(
      (option) => option.set_default == 1,
    );
    // this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  methods: {
    ...optionalfeeMethods,
    ...optionalfeepaymentMethods,
    ...schoolclassMethods,
    ...schooltermMethods,
    ...studentMethods,
    ...feescartMethods,
    ...paymentoptionMethods,
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name} `;
    },
    commas(x) {
      if (
        x === null ||
        x === undefined ||
        x === "" ||
        Number.isNaN(Number(x))
      ) {
        return "0";
      }
      return Number(x).toLocaleString();
    },
    getBalance(item) {
      const feeAmount = Number(item.fees[0].amount ?? 0);
      const paidAmount = Number(item.sum_paid ?? 0);
      return feeAmount - paidAmount;
    },
    printPDF() {
      const element = document.getElementById("print-section");
      const options = {
        filename: this.title + ".pdf",
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      html2pdf()
        .from(element)
        .set(options)
        .save();
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, student, fees, term, amount, paid) {
      this.id = id;
      this.student = student;
      this.fees = fees;
      this.schoolterm = term;
      this.amount = amount;
      this.amountpaid = paid;
      this.$bvModal.show("edit-optionalfeespayment");
    },
    pay(id, receipt_id, student, balance) {
      this.id = id;
      this.receipt_id = receipt_id;
      this.student = student;
      this.bal = balance;
      this.amount_paid = "";
      this.$bvModal.show("make-payment");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("delete-optionalfeespayment");
    },
    async SetFees() {
      let url = `/setpayment/${this.student.student.student_id},${this.schoolterm.id},${this.year},${this.fees.id},`;
      await axios.get(url).then((response) => {
        this.setpayments = response.data.setpayments;
        this.amount = response.data.setpayments[0].amount;
      });
    },
    async addFeesPayment() {
      this.loader = true;
      let formData = new FormData();
      formData.append("student", this.student.student.student_id);
      formData.append("amountpaid", this.amountpaid);
      //formData.append("amount", this.amount);
      formData.append("fees", this.fees.id);
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      let url = "/addoptionalfeespayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFeesPayments();
          this.$bvModal.hide("new-optionalfeespayment");
          this.student = "";
          this.schoolterm = "";
          this.amountpaid = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
          this.loader = false;
        }
      });
    },
    async editFeesPayment() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("student", this.student);
      formData.append("amountpaid", this.amountpaid);
      formData.append("fees", this.fees.id);
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      let url = "/updateoptionalfeespayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFeesPayments();
          this.$bvModal.hide("edit-optionalfeespayment");
          this.student = "";
          this.schoolterm = "";
          this.amountpaid = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async makePayment() {
      let formData = new FormData();
      formData.append("receipt_id", this.receipt_id);
      formData.append("student", this.student);
      formData.append("amount_paid", this.amount_paid);
      let url = "/makeoptionalfeespayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFeesPayments();
          this.$bvModal.hide("make-payment");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },

    async removeFeesPayment() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeoptionalfeespayment";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchOptionalFeesPayments();
          this.$bvModal.hide("delete-optionalfeespayment");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    FilterData() {
      this.filterOptionalFeesPayments({
        schoolterm: this.schoolterm.id,
        year: this.year,
        fees: this.fees.id,
      });
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleString() : "-";
    },
  },
};
</script>
